import { mapActions } from 'vuex'
import XButton from './quest_modal/XButton'
import GoogleButton from './quest_modal/GoogleButton'
import CopyUrlButton from './quest_modal/CopyUrlButton'
import { typeColors, periodColors } from './quest_modal/constants'

export default {
  props: ['showContent', 'quest'],
  components: {
    XButton,
    GoogleButton,
    CopyUrlButton
  },
  data () {
    return {
      achieved: this.quest.is_achieved
    }
  },
  watch: {
    achieved (newValue, oldValue) {
      if (this.achieved) {
        localStorage.setItem(this.achievedId(this.quest.quest_id), 'dummy')
      } else {
        localStorage.removeItem(this.achievedId(this.quest.quest_id))
      }
    },
    quest () {
      this.achieved = this.quest.is_achieved
    }
  },
  methods: {
    closeModal () {
      this.$emit('close')
    },
    typeClass (type) {
      return 'quest-type-' + type
    },
    periodClass (period) {
      return 'quest-period-' + period
    },
    backgroundColor (type) {
      return typeColors[type] || '#ffffff'
    },
    textColor (period) {
      return periodColors[period] || '#ffffff'
    },
    achievedId (id) {
      return 'achieved-' + id
    },
    ...mapActions(['setModalQuest'])
  }
}



// WEBPACK FOOTER //
// ./src/components/QuestModalMixin.js